// Must stay first: inside Claude it sets up the session and API transport
// before anything else loads. A no-op in the browser (see embed/embed.js).
import { isEmbedded, embedInitialPath } from './embed/embed';
import React from 'react';
import ReactDOM from 'react-dom';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './index.css';
import App from './App';
import { BrowserRouter, MemoryRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store, persistor } from '../src/redux/store/store';
import { PersistGate } from 'redux-persist/integration/react';
import { ToastProvider } from './toast/toastContext';
import CustomToaster from './toast/customToaster';
import { ErrorBoundary } from 'react-error-boundary';
import FallBack from './pages/fallback';
import { BannerProvider } from './banner/bannerContext';
import { ThemeModeProvider } from './contexts/themeContext';
import { AssistantProvider } from './contexts/assistantContext';
import { prepareEmbeddedSession } from './embed/embedBootstrap';
import { relayGoogleOAuthReturn } from './utils/googleOAuthReturn';

// Claude's frame has no address bar of its own to route on, so inside Claude
// the router keeps its history in memory. The browser is unchanged.
const Router = isEmbedded ? MemoryRouter : BrowserRouter;
const routerProps = isEmbedded ? { initialEntries: [embedInitialPath] } : {};

const render = () =>
  ReactDOM.render(
    <Router {...routerProps}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ThemeModeProvider>
            <ToastProvider>
              <ErrorBoundary FallbackComponent={FallBack}>
                <BannerProvider>
                  <AssistantProvider>
                    <App />
                  </AssistantProvider>
                </BannerProvider>
              </ErrorBoundary>
              <CustomToaster />
            </ToastProvider>
          </ThemeModeProvider>
        </PersistGate>
      </Provider>
    </Router>,
    document.getElementById('root')
  );

// Inside Claude the profile and coding lists load first (embed/embedBootstrap.js);
// in the browser the app renders straight away, as it always has — except in the
// Google Drive sign-in popup, which hands Google's answer to its opener and
// closes without rendering anything (see utils/googleOAuthReturn.js).
if (isEmbedded) prepareEmbeddedSession(store, persistor).finally(render);
else if (!relayGoogleOAuthReturn(window)) render();

reportWebVitals();
